import axios from "axios";
import { store } from "../redux/store";
import { userAction } from "../redux/reducers/user";
import { Alert } from "react-native";

const api = axios.create();

api.interceptors.request.use(
  async (config) => {
    const accessToken = await getAccessToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      userAction.logoutUser();
      Alert.alert("Unauthorized. Logging out.");
      return Promise.reject({
        message: "Unauthorized. Logging out.",
        status: 401,
      });
    }

    return Promise.reject(error);
  }
);

// Mock function to retrieve access token
const getAccessToken = async () => {
  const access_token = store.getState().user?.userData?.access_token;
  console.log('@ token : ', access_token);
  return access_token;
};

export default api;
